import Icons from "../Icons/Icons";
import React, {useState} from "react";
import {getTrackBackground, Range} from "react-range";

const Label = (props) => {
    return (<label className={`mb--3 mt--1 w100`}>{props.label}</label>)
}

const Input = React.forwardRef(({label, ariaLabel, placeholder, ...props}, ref) => (
    <label aria-label={ariaLabel ?? label ?? placeholder ?? "Pole tekstowe"} style={{display: "contents"}}>
        <input
            placeholder={placeholder ?? label}
            aria-label={ariaLabel ?? label}
            ref={ref}
            {...props}
        />
    </label>));

const Select = React.forwardRef(({onChange, onBlur, name, label, options}, ref) => (<>
    <div className={"form__select w100"}>
        <select className={"form__control"} aria-label={label ?? `Wybierz z listy`} name={name} ref={ref}
                onChange={onChange} onBlur={onBlur}>
            {label && <option value="" disabled>{label}</option>}
            {options && options.map((item, key) => (
                <option className={`disabled`} value={item.value} key={`${key}${item}`}>{item.name}</option>))}
        </select>
        <Icons name={"down"}/>
    </div>
</>))

const Textarea = React.forwardRef(({onChange, onBlur, name, placeholder}, ref) => (
    <textarea className={"form__control form__textarea"} name={name} ref={ref} onChange={onChange} onBlur={onBlur}
              aria-label={placeholder} placeholder={placeholder}/>))

const Checkbox = React.forwardRef(({onChange, onBlur, name, placeholder}, ref) => (

    <label className={"flex flex--center"} aria-label={placeholder}>
        <input type={"checkbox"} name={name} ref={ref} onChange={onChange} onBlur={onBlur}/>
        <span className={"ml--3"} dangerouslySetInnerHTML={{__html: placeholder}}></span>
    </label>

))

const CustomRange = (props) => {

    return (<Range
        step={50}
        min={props.installment}
        max={props.max}
        values={props.value}
        className={"range"}
        onChange={(values) => props.onChange(values)}
        renderTrack={({props, children}) => (<div
            {...props}
            style={{
                ...props.style, background: getTrackBackground({
                    values: props.value,
                    colors: ['var(--primary)', 'var(--gray-50)'],
                    min: props.installment,
                    max: props.max
                }),
            }}
            aria-label={"Suwak zakresu"}
            className={"range__track"}
        >
            {children}
        </div>)}
        renderThumb={({props}) => (<div
            {...props}
            style={{
                ...props.style
            }}
            className={"range__thumb"}
        >
            <Icons name={"left"}/>
            <Icons name={"right"}/>
        </div>)}
    />)
}

const Button = (props) => {

    let cssClass = ['btn'], type = props.submit ? `submit` : `button`;

    if (props.primary) {
        cssClass.push(`btn--primary`)
    }

    if (props.link) {
        cssClass.push(`btn--link`)
    }

    if (props.border) {
        cssClass.push(`btn--border`)
    }

    if (props.icon) {
        cssClass.push(`btn--icon`)
    }

    if (props.className) {
        cssClass.push(props.className)
    }

    return (<button className={cssClass.join(` `)} aria-label={props.title ?? props.text ?? 'Przycisk'} type={type}>
        {props.text ?? ``}
        {props.icon && <Icons name={`${props.icon}`}/>}
    </button>)
}

const Group = (props) => {
    return (<div className={`form__group flex flex--middle ${props.className} ${props.columns ? `flex--column` : ``}`}>
        {props.children}
    </div>)

}

const Error = (props) => {
    return <span className={"form-label form-label--error flex w100 py--1"}>{props.children}</span>
}


export default {
    Button, Input, Group, Error, CustomRange, Checkbox, Select, Textarea
}

